import { render, staticRenderFns } from "./defualtModule.vue?vue&type=template&id=5a01504b&"
import script from "./defualtModule.vue?vue&type=script&lang=js&"
export * from "./defualtModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports